// schoolYearData.js

export const SCHOOL_YEAR_2026_2027 = {
  start: "2026-08-10",
  end: "2027-07-05",

  holidays: [
    {
      title: "Sommerferien",
      start: "2026-08-10",
      end: "2026-08-16",
    },
    {
      title: "Herbstferien",
      start: "2026-09-28",
      end: "2026-10-11",
    },
    {
      title: "Sonderwoche",
      start: "2026-10-12",
      end: "2026-10-18",
    },
    {
      title: "Weihnachtsferien",
      start: "2026-12-21",
      end: "2027-01-03",
    },
    {
      title: "Fasnachtsferien",
      start: "2027-02-01",
      end: "2027-02-14",
    },
    {
      title: "Sondertage 1-3",
      start: "2027-03-17",
      end: "2027-03-19",
    },
    {
      title: "Osterferien",
      start: "2027-03-29",
      end: "2027-04-11",
    },
    {
      title: "Sondertage 4-5",
      start: "2027-04-19",
      end: "2027-04-20",
    },
    {
      title: "Sommerferien",
      start: "2027-07-05",
      end: "2027-08-16",
    },
  ],
};
